import { useEffect, useState } from 'react'
import Form, { Input, Select } from '../../../../../../components/Form'
import { useToast } from '../../../../../../hooks/toast'
import { FormContainer } from './styles'
import api from 'services/api'
import { SearchComponentDish } from './SearchComponentDish'
import { genericMaskWithTwoZeroWithPoint } from 'utlis/mask'

type TypesFormProps = {
  handleClickOnAddDishComposition?: (dishIngredient: IDishComposition) => void
  handleClickOnEditDishComposition?: (dishIngredient: IDishComposition) => void
  initialValues?: {
    dish_id?: number
    dish_composition?: IDishComposition
  }
  typeForm: 'create' | 'update'
}

export const FormAddDishComposiiton = ({
  handleClickOnAddDishComposition,
  handleClickOnEditDishComposition,
  typeForm,
  initialValues
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()

  const [defaultValues, setDefaultValues] = useState<IDishComposition>()
  const [dishesTypes, setDishesTypes] = useState<IDishType[]>([])
  const [dishType, setDishType] = useState<number>()
  const [dishCompositionId, setDishCompositionId] = useState<number>()
  const [dishCompositionName, setDishCompositionName] = useState('')
  const [unitMeasure, setUnitMeasure] = useState<string>()
  const [measure, setMeasure] = useState<string>('')

  useEffect(() => {
    if (initialValues.dish_composition) {
      setDefaultValues({
        ...initialValues.dish_composition,
        quantity: genericMaskWithTwoZeroWithPoint(
          initialValues.dish_composition.quantity
        ),
        dishe_type: initialValues.dish_composition.dishComposition?.dish_type_id
      })
      let unitMeasure = ''
      if (initialValues.dish_composition.measure) {
        if (
          ['Pedaco', 'Unidade'].includes(initialValues.dish_composition.measure)
        ) {
          unitMeasure = 'unit'
        }
        if (
          ['Litro', 'Mililitro'].includes(
            initialValues.dish_composition.measure
          )
        ) {
          unitMeasure = 'volume'
        }
        if (
          ['Kilo', 'Grama', 'Miligrama'].includes(
            initialValues.dish_composition.measure
          )
        ) {
          unitMeasure = 'weight'
        }
      }

      setUnitMeasure(unitMeasure)
      setMeasure(initialValues.dish_composition.measure)
      setDishCompositionName(
        initialValues.dish_composition.dishComposition?.name
      )
      setDishType(initialValues.dish_composition.dishComposition?.dish_type_id)
    }
  }, [initialValues.dish_composition])

  useEffect(() => {
    ;(async () => {
      const response = await api.get('commercial/dishesTypes/listOptions')

      setDishesTypes(response.data)
    })()
  }, [])

  const handleSelectDish = (
    id?: number,
    dishName?: string,
    unitMeasure?: string
  ) => {
    setDishCompositionId(id)
    setDishCompositionName(dishName)
    setUnitMeasure(unitMeasure as INGREDIENT_TYPES)
  }

  const onSubmitForm = async (data: any) => {
    try {
      if (typeForm === 'create') {
        handleClickOnAddDishComposition({
          id: 0,
          dish_id: 0,
          dish_composition_id: dishCompositionId,
          measure,
          quantity: data.quantity.replace('.', '').replace(',', '.'),
          dishComposition: {
            name: dishCompositionName
          }
        })
      } else {
        handleClickOnEditDishComposition({
          id: initialValues.dish_composition.id,
          dish_id: initialValues.dish_id,
          dish_composition_id:
            initialValues.dish_composition.dish_composition_id,
          measure,
          quantity: data.quantity.replace('.', '').replace(',', '.'),
          dishComposition: {
            name: dishCompositionName
          }
        })
      }
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
      }
    }
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={defaultValues}>
      <>
        <div className="card mb-5 mb-xl-10">
          <FormContainer className="form-body">
            <div className="row">
              <Select
                name="dishe_type"
                label="Tipo de item"
                className="col-md-3"
                rules={{ required: true }}
                options={dishesTypes.map(dishType => ({
                  name: dishType.name,
                  value: dishType.id
                }))}
                value={dishType}
                onChange={e => setDishType(Number(e.target.value))}
                blank
                defaultValue={''}
              />
              <div className="col-md-5">
                <SearchComponentDish
                  dishTypeId={dishType}
                  dishName={dishCompositionName}
                  handleSelectDish={handleSelectDish}
                />
              </div>
              {unitMeasure && ['weight', 'volume'].includes(unitMeasure) && (
                <Select
                  name="measure"
                  label="Medida"
                  options={
                    unitMeasure === 'weight'
                      ? [
                          { name: 'Kilo', value: 'Kilo' },
                          { name: 'Grama', value: 'Grama' },
                          { name: 'Miligrama', value: 'Miligrama' }
                        ]
                      : unitMeasure === 'volume'
                      ? [
                          { name: 'Litro', value: 'Litro' },
                          { name: 'Mililitro', value: 'Mililitro' }
                        ]
                      : []
                  }
                  blank
                  value={measure}
                  onChange={({ target }) => setMeasure(target.value)}
                  defaultValue={''}
                  className="col-md-2"
                  rules={{ required: true }}
                />
              )}
              <Input
                name="quantity"
                label="Qtd."
                price
                className="col-md-2"
                rules={{ required: true }}
              />
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
